<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="global-icon" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">IPCR Targets</div>

                <div class="dialog-subtitle">
                  Manage target objectives and performance expectations.
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="closeD()">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-row>
            <v-col cols="12" v-if="isSubmitted">
              <v-stepper alt-labels class="elevation-0">
                <v-stepper-header>
                  <v-stepper-step
                    step="1"
                    class="pa-5"
                    :complete="assesed_by_status == 2 ? true : false"
                    :rules="[() => assesed_by_status != 3]"
                    color="#6DB249"
                  >
                    <div style="width: 200px" class="text-center">
                      {{ getUserName(assessed_by) }}<br />
                      <small>Assessed By</small>
                    </div>
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
            <v-col cols="8" class="flex-items mt-2">
              <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                <v-tab
                  :disabled="loading"
                  v-for="tab in tabList"
                  :key="tab.id"
                  @change="changeTab(tab)"
                  >{{ tab.name }}</v-tab
                >
              </v-tabs>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="d-flex justify-end mt-2 mr-2">
              <v-btn
                v-if="shouldSubmit() && tab > 1"
                @click="tab == 2 ? AddFunction() : AddSupportFunction()"
                class="btn-save"
              >
                Add
              </v-btn>

              <v-btn
                v-if="
                  shouldSubmit() &&
                    tab == 1 &&
                    this.data &&
                    this.data.facultyType != 'non-designated'
                "
                @click="AddFunction()"
                class="btn-save"
              >
                Add
              </v-btn>
            </v-col>
            <v-col cols="12" class="pt-2 px-4">
              <div class="my-2" v-if="data && data.isFaculty && tab != 1">
                <div class="text-subtitle-1 blue--text mx-2">
                  Please add a minimum of
                  {{
                    tab == 2
                      ? data.facultyStrategicIndicator + " Indicators"
                      : "2 Professional Development"
                  }}
                </div>
              </div>
              <!-- non-teaching -->
              <v-card class="dt-container" elevation="0" outlined>
                <v-data-table
                  v-if="data && data.isFaculty == 0"
                  :headers="tab != 3 ? cf_sf_headers : support_headers"
                  :items="dataItem"
                  :items-per-page="-1"
                  :item-class="setPendingClass"
                  class="text-body-2"
                >
                  <template v-slot:[`item.mfo`]="{ item }">
                    <div class="preserve-whitespace">
                      {{ item.mfo }}
                    </div>
                  </template>

                  <template v-slot:[`item.efficiency`]="{ item }">
                    {{
                      item.eff_is_rated
                        ? item.efficiency_type == "percentage"
                          ? item.efficiency + "%"
                          : item.efficiency
                        : "NR"
                    }}
                  </template>
                  <template v-slot:[`item.quality`]="{ item }">
                    {{ item.qly_is_rated ? item.quality : "NR" }}
                  </template>
                  <template v-slot:[`item.timeliness`]="{ item }">
                    <span v-if="item.t_num">
                      {{
                        item.timeliness_is_rated
                          ? item.t_num + " " + item.timeliness
                          : "NR"
                      }}
                    </span>
                    <span v-else>
                      {{ item.timeliness_is_rated ? item.timeliness : "NR" }}
                    </span>
                  </template>
                  <template v-slot:[`item.success_indicator`]="{ item }">
                    <div class="preserve-whitespace">
                      {{ item.success_indicator }}
                    </div>
                  </template>
                  <template v-slot:[`item.actual_accom`]="{ item }">
                    <div class="preserve-whitespace">
                      {{ item.actual_accom }}
                    </div>
                  </template>

                  <template v-slot:[`item.eqt`]="{ item }">
                    <center>
                      <div style="width: 40%" class="pa-2">
                        <div class="d-flex justify-space-between align-center">
                          <div class="">Efficiency</div>
                          <div class="">
                            <v-icon v-if="item.eff_is_rated" color="#519043"
                              >mdi-check-bold</v-icon
                            >
                            <div
                              class="text-caption font-weight-bold"
                              v-if="!item.eff_is_rated"
                            >
                              NR
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-space-between align-center">
                          <div class="">Quality</div>
                          <div class="">
                            <v-icon v-if="item.qly_is_rated" color="#519043"
                              >mdi-check-bold</v-icon
                            >
                            <div
                              class="text-caption font-weight-bold"
                              v-if="!item.qly_is_rated"
                            >
                              NR
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-space-between align-center">
                          <div class="">Timeliness</div>
                          <div class="">
                            <v-icon
                              v-if="item.timeliness_is_rated"
                              color="#519043"
                              >mdi-check-bold</v-icon
                            >
                            <div
                              class="text-caption font-weight-bold"
                              v-if="!item.timeliness_is_rated"
                            >
                              NR
                            </div>
                          </div>
                        </div>
                      </div>
                    </center>
                  </template>

                  <template
                    v-if="shouldSubmit()"
                    v-slot:[`item.action`]="{ item }"
                  >
                    <div class="button-group my-2">
                      <v-btn
                        v-if="
                          isSubmitted &&
                            assesed_by_status == 3 &&
                            (tab != 3
                              ? hasUnOpennedRemarks(item.pendingRemarks) > 0
                              : false)
                        "
                        x-small
                        class="global-btn-save"
                        @click="showPendingRemarks(item.pendingRemarks)"
                        >Show Remarks</v-btn
                      >
                      <v-btn
                        v-if="
                          tab != 3 ||
                            (item.type &&
                              (item.type == 'Intervening Function' ||
                                item.type == 'Professional Development'))
                        "
                        class="global-btn-save"
                        @click="edit(item)"
                        >Update</v-btn
                      >
                      <v-btn
                        v-if="showDelete(item)"
                        class="global-btn-cancel"
                        @click="deleteItem(item)"
                        >Delete</v-btn
                      >
                    </div>
                  </template>
                </v-data-table>
              </v-card>
              <!-- faculty -->

              <v-data-table
                v-if="data && data.isFaculty == 1"
                :headers="tab != 3 ? type_headers : support_headers"
                :items="formatTableData"
                :items-per-page="-1"
                :show-expand="tab != 3"
                :expanded.sync="expanded"
                item-key="category"
                single-expand
                :hide-default-footer="tab != 3"
              >
                <template v-slot:[`item.category`]="{ item }">
                  <div class="font-weight-bold">
                    {{ item.category }}
                  </div>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="pa-4">
                    <v-data-table
                      :headers="cf_sf_headers"
                      :items="item.data"
                      :items-per-page="-1"
                      :item-class="setPendingClass"
                    >
                      <template v-slot:[`item.mfo`]="{ item }">
                        <div class="preserve-whitespace">
                          {{ item.mfo }}
                        </div>
                      </template>

                      <template v-slot:[`item.efficiency`]="{ item }">
                        {{
                          item.eff_is_rated
                            ? item.efficiency_type == "percentage"
                              ? item.efficiency + "%"
                              : item.efficiency
                            : "NR"
                        }}
                      </template>
                      <template v-slot:[`item.quality`]="{ item }">
                        {{ item.qly_is_rated ? item.quality : "NR" }}
                      </template>
                      <template v-slot:[`item.timeliness`]="{ item }">
                        {{ item.timeliness_is_rated ? item.timeliness : "NR" }}
                      </template>
                      <template v-slot:[`item.success_indicator`]="{ item }">
                        <div class="preserve-whitespace">
                          {{ item.success_indicator }}
                        </div>
                      </template>
                      <template v-slot:[`item.actual_accom`]="{ item }">
                        <div class="preserve-whitespace">
                          {{ item.actual_accom }}
                        </div>
                      </template>

                      <template v-slot:[`item.eqt`]="{ item }">
                        <center>
                          <div style="width: 40%" class="pa-2">
                            <div
                              class="d-flex justify-space-between align-center"
                            >
                              <div class="">Efficiency</div>
                              <div class="">
                                <v-icon v-if="item.eff_is_rated" color="#519043"
                                  >mdi-check-bold</v-icon
                                >
                                <div
                                  class="text-caption font-weight-bold"
                                  v-if="!item.eff_is_rated"
                                >
                                  NR
                                </div>
                              </div>
                            </div>
                            <div
                              class="d-flex justify-space-between align-center"
                            >
                              <div class="">Quality</div>
                              <div class="">
                                <v-icon v-if="item.qly_is_rated" color="#519043"
                                  >mdi-check-bold</v-icon
                                >
                                <div
                                  class="text-caption font-weight-bold"
                                  v-if="!item.qly_is_rated"
                                >
                                  NR
                                </div>
                              </div>
                            </div>
                            <div
                              class="d-flex justify-space-between align-center"
                            >
                              <div class="">Timeliness</div>
                              <div class="">
                                <v-icon
                                  v-if="item.timeliness_is_rated"
                                  color="#519043"
                                  >mdi-check-bold</v-icon
                                >
                                <div
                                  class="text-caption font-weight-bold"
                                  v-if="!item.timeliness_is_rated"
                                >
                                  NR
                                </div>
                              </div>
                            </div>
                          </div>
                        </center>
                      </template>

                      <template
                        v-if="shouldSubmit()"
                        v-slot:[`item.action`]="{ item }"
                      >
                        <v-btn
                          v-if="
                            isSubmitted &&
                              assesed_by_status == 3 &&
                              (tab != 3
                                ? hasUnOpennedRemarks(item.pendingRemarks) > 0
                                : false)
                          "
                          x-small
                          class="my-1"
                          @click="showPendingRemarks(item.pendingRemarks)"
                          outlined
                          color="primary"
                          block
                          >Show Remarks</v-btn
                        >
                        <v-btn
                          v-if="
                            tab != 3 ||
                              (item.type &&
                                (item.type == 'Intervening Function' ||
                                  item.type == 'Professional Development'))
                          "
                          block
                          x-small
                          class="mt-1"
                          @click="edit(item)"
                          outlined
                          color="#519043"
                          >Update</v-btn
                        >
                        <v-btn
                          v-if="showDelete(item)"
                          x-small
                          class="my-1"
                          @click="deleteItem(item)"
                          outlined
                          color="red"
                          block
                          >Delete</v-btn
                        >
                      </template>
                    </v-data-table>
                  </td>
                </template>
                <template v-slot:[`item.mfo`]="{ item }">
                  <div class="preserve-whitespace">
                    {{ item.mfo }}
                  </div>
                </template>

                <template v-slot:[`item.efficiency`]="{ item }">
                  {{
                    item.eff_is_rated
                      ? item.efficiency_type == "percentage"
                        ? item.efficiency + "%"
                        : item.efficiency
                      : "NR"
                  }}
                </template>
                <template v-slot:[`item.quality`]="{ item }">
                  {{ item.qly_is_rated ? item.quality : "NR" }}
                </template>
                <template v-slot:[`item.timeliness`]="{ item }">
                  {{ item.timeliness_is_rated ? item.timeliness : "NR" }}
                </template>
                <template v-slot:[`item.success_indicator`]="{ item }">
                  <div class="preserve-whitespace">
                    {{ item.success_indicator }}
                  </div>
                </template>
                <template v-slot:[`item.actual_accom`]="{ item }">
                  <div class="preserve-whitespace">
                    {{ item.actual_accom }}
                  </div>
                </template>

                <template v-slot:[`item.eqt`]="{ item }">
                  <center>
                    <div style="width: 40%" class="pa-2">
                      <div class="d-flex justify-space-between align-center">
                        <div class="">Efficiency</div>
                        <div class="">
                          <v-icon v-if="item.eff_is_rated" color="#519043"
                            >mdi-check-bold</v-icon
                          >
                          <div
                            class="text-caption font-weight-bold"
                            v-if="!item.eff_is_rated"
                          >
                            NR
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-space-between align-center">
                        <div class="">Quality</div>
                        <div class="">
                          <v-icon v-if="item.qly_is_rated" color="#519043"
                            >mdi-check-bold</v-icon
                          >
                          <div
                            class="text-caption font-weight-bold"
                            v-if="!item.qly_is_rated"
                          >
                            NR
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-space-between align-center">
                        <div class="">Timeliness</div>
                        <div class="">
                          <v-icon
                            v-if="item.timeliness_is_rated"
                            color="#519043"
                            >mdi-check-bold</v-icon
                          >
                          <div
                            class="text-caption font-weight-bold"
                            v-if="!item.timeliness_is_rated"
                          >
                            NR
                          </div>
                        </div>
                      </div>
                    </div>
                  </center>
                </template>

                <template
                  v-if="shouldSubmit()"
                  v-slot:[`item.action`]="{ item }"
                >
                  <v-btn
                    v-if="
                      isSubmitted &&
                        assesed_by_status == 3 &&
                        (tab != 3
                          ? hasUnOpennedRemarks(item.pendingRemarks) > 0
                          : false)
                    "
                    x-small
                    class="my-1"
                    @click="showPendingRemarks(item.pendingRemarks)"
                    outlined
                    color="primary"
                    block
                    >Show Remarks</v-btn
                  >
                  <v-btn
                    v-if="
                      tab != 3 ||
                        (item.type &&
                          (item.type == 'Intervening Function' ||
                            item.type == 'Professional Development'))
                    "
                    block
                    x-small
                    class="mt-1"
                    @click="edit(item)"
                    outlined
                    color="#519043"
                    >Update</v-btn
                  >
                  <v-btn
                    v-if="showDelete(item)"
                    x-small
                    class="my-1"
                    @click="deleteItem(item)"
                    outlined
                    color="red"
                    block
                    >Delete</v-btn
                  >
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row v-if="isSubmitted && assesed_by_status == 2" class="mt-4">
            <v-col cols="12">
              <v-divider class="mb-4"></v-divider>
              <div class="global-comment-card">
                <div class="global-comment-header">
                  <div class="global-comment-icon">
                    <v-icon color="#147452"> mdi-message-text-outline </v-icon>
                  </div>

                  <div>
                    <div class="global-comment-title">
                      Comments & Recommendations
                    </div>

                    <div class="global-comment-subtitle">
                      Development feedback and recommendations from the
                      evaluator
                    </div>
                  </div>
                </div>

                <div class="global-comment-content">
                  {{ targetRating.comments || "No comments provided." }}
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-card-text class="pa-1 mr-3 mt-8 d-flex justify-end">
            <v-btn
              class="btn-print"
              outlined
              @click="printTargets()"
              v-if="assesed_by_status == 2"
            >
              Print
            </v-btn>
            <v-spacer></v-spacer>

            <v-btn class="btn-cancel mr-3" outlined @click="closeD()">
              Close
            </v-btn>

            <!-- <v-btn
              v-if="shouldSubmit()"
              class="btn-save"
              @click="submitTarget()"
            >
              Submit
            </v-btn> -->
          </v-card-text>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog
      v-model="confirmDialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="delete-icon"><icon name="delete" /></div>

          <div class="delete-title">Delete Record?</div>

          <div class="delete-description">
            This action will permanently remove this information from the
            system.
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            @click="cancelDelete()"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            class="btn-delete"
            :loading="isButtonLoading"
            :disabled="isButtonLoading"
            @click="confirmDelete()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmSubmitDialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="submit-icon">
            <icon name="circle-check" />
          </div>

          <div class="delete-title">Submit for Approval?</div>

          <div class="delete-description">
            Are you sure you want to submit this
            <strong>Targets for Approval</strong>?
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            :disabled="confirmBtnLoading"
            @click="cancelConfirm()"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            color="#147452"
            depressed
            :loading="confirmBtnLoading"
            :disabled="confirmBtnLoading"
            class="btn-save"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <IPCRFunctionDialog
      :data="ipcrData"
      :action="action"
      :target_type="tab"
      :ipcrID="id"
      :year="ipcrYear"
      :tab="tab"
      :taggedIDs="taggedIDs"
    />
    <UpdateSupportFunctionDialog
      :data="ipcrSupData"
      :action="action"
      :ipcrID="id"
    />

    <AddIPCRSupportUtilDialog
      :moduleFrom="'Employee'"
      :data="ipcrSupport"
      :action="action"
      :ipcrID="id"
    />

    <ViewRemarksTimelineDialog
      :data="pendingList"
      :viewFrom="'Owner'"
      v-on:closeRemarksTimeline="initialize()"
    />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :timeout="fadeAwayMessage.timeout"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import ViewRemarksTimelineDialog from "./ViewRemarksTimelineDialog.vue";
import icon from "@/assets/icon.vue";
export default {
  components: {
    icon,
    IPCRFunctionDialog: () => import("../Forms/IPCRFunctionDialog.vue"),
    UpdateSupportFunctionDialog: () =>
      import("../Forms/UpdateSupportFunctionDialog.vue"),
    AddIPCRSupportUtilDialog: () =>
      import("../Forms/AddIPCRSupportUtilDialog.vue"),
    ViewRemarksTimelineDialog,
  },
  props: {
    data: null,
  },
  data() {
    return {
      expanded: [],
      loading: false,
      remarksData: [],
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      options: {},
      action: null,
      taggedIDs: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        timeout: 1500,
        top: 10,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
      ],
      ipcrData: null,
      ipcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assesed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      users: [],
      id: null,
      ipcrYear: null,
      ipcrSupport: null,
      dataItem: [],
      isButtonLoading: false,
      pendingList: [],
      type_headers: [
        {
          text: "Category",
          value: "category",
          align: "start",
          valign: "start",
          sortable: false,
        },
      ],
      cf_sf_headers: [
        {
          text: "Major Final Output",
          value: "mfo",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Efficiency",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Quality",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Timeliness",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Action",
          value: "action",
          align: "center",
          width: 150,
        },
      ],
      support_headers: [
        {
          text: "Type",
          value: "type",
          width: 200,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 400,
          valign: "center",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "start",
          width: 400,
          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          width: 300,
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "center",
          width: 150,
        },
      ],
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("IPCR data", data);
        this.getUsers();
        this.activeTab = { id: 1, name: "Core Functions" };

        // if (data.isFaculty) {
        //   const checkType = (obj) => obj.text === "Type";

        //   if (!this.cf_sf_headers.some(checkType)) {
        //     this.cf_sf_headers.splice(5, 0, {
        //       text: "Type",
        //       value: "target_for",
        //       align: "center",
        //       valign: "center",
        //       sortable: false,
        //     });
        //   }
        // }
        this.ipcrYear = data.year;
        this.id = data.id;
        this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeIPCRFunctionDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closePerformanceEvaluationDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeMPORDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeUpdateSupportFunctionDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeAddIPCRSupportUtilDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeIPCRFunctionDialog");
    this.eventHub.$off("closeAddIPCRSupportUtilDialog");
    this.eventHub.$off("closePerformanceEvaluationDialog");
    this.eventHub.$off("closeMPORDialog");
    this.eventHub.$off("closeUpdateSupportFunctionDialog");
  },
  computed: {
    getProfDevCount() {
      let cnt = 0;
      if (this.tab == 3 && this.data.isFaculty == 1) {
        for (let i = 0; i < this.dataItem.length; i++) {
          if (this.dataItem[i].type == "Professional Development") {
            cnt++;
          }
        }
      }
      return cnt;
    },

    checkIsQualifiedToSubmit() {
      return true;
    },

    formatTableData() {
      let data = [];
      if (this.data.isFaculty == 0) {
        data = this.dataItem;
      } else {
        if (this.tab == 3) {
          data = this.dataItem;
        } else if (this.tab == 1) {
          if (this.data.facultyType == "designated") {
            let designation_percent = (
              (parseInt(this.data.facultyDeloadedUnits) /
                parseInt(this.data.facultyUnits)) *
              100
            ).toFixed(2);
            let instruction_percent = 100 - designation_percent;

            let instruction = this.dataItem.filter(
              (cat) => cat.target_for === "Instruction",
            );
            let designation = this.dataItem.filter(
              (cat) => cat.target_for === "Designation",
            );

            data.push(
              {
                category: `Instruction (${instruction_percent}%)`,
                percentage: instruction_percent,
                data: instruction,
              },
              {
                category: `Designation (${designation_percent}%)`,
                percentage: designation_percent,
                data: designation,
              },
            );
          } else {
            data.push({
              category: `Instruction (${this.data.util.cf_percentage * 100}%)`,
              percentage: null,
              data: this.dataItem,
            });
          }
        } else if (this.tab == 2) {
          let research = this.dataItem.filter(
            (cat) => cat.target_for === "Research",
          );
          let extension = this.dataItem.filter(
            (cat) => cat.target_for === "Extension and Production",
          );
          if (this.data.facultyType == "designated") {
            data.push(
              {
                category: "Research",
                percentage: null,
                data: research,
              },
              {
                category: "Extension and Production",
                percentage: null,
                data: extension,
              },
            );
          } else {
            data.push(
              {
                category: `Research (${this.data.util.sp_percentage_research *
                  100}%)`,
                percentage:
                  (this.data.util.sp_percentage_research * 100).toString() +
                  "%",
                data: research,
              },
              {
                category: `Extension and Production (${this.data.util
                  .sp_percentage_extension * 100}%)`,
                percentage:
                  (this.data.util.sp_percentage_extension * 100).toString() +
                  "%",
                data: extension,
              },
            );
          }
        }
      }
      return data;
    },
  },

  methods: {
    initialize() {
      this.loading = true;
      this.loadRemarks(this.id);

      // console.log("TAB", this.tab);
      if (this.tab != 3) {
        if (this.id && this.tab) {
          this.axiosCall(
            "/ipcr-target/getMyIPCRTarget/" + this.id + "/" + this.tab,
            "GET",
          ).then((res) => {
            if (res) {
              this.getMyAddedIPCRTarget(res.data.targets);
              console.log("TTTTT", res.data);
              this.targetRating = res.data.target_rating;
              this.isSubmitted = res.data.target_rating.isSubmitted;
              this.dataItem = res.data.targets;
              this.assessed_by = res.data.target_rating.assesed_by;
              this.assesed_by_status = res.data.target_rating.assesed_by_status;
              this.loading = false;
            }
          });
        }
      } else {
        //support function
        let url;
        if (this.data.isFaculty) {
          //teaching
          url = "/ipcr-target/getMyIPCRSFAndProfessionalDevelopment/" + this.id;
        } else {
          //non-teaching
          url =
            "/ipcr-target/getMyIPCRSupportInterveningFunctionTarget/" + this.id;
        }

        this.axiosCall(url, "GET").then((res) => {
          if (res) {
            console.log("asdsss", res.data);
            if (res.data.status == 200) {
              this.targetRating = res.data.target_rating;
              this.isSubmitted = res.data.target_rating
                ? res.data.target_rating.isSubmitted
                : null;
              this.assessed_by = res.data.target_rating.assesed_by;
              this.assesed_by_status = res.data.target_rating.assesed_by_status;
              this.dataItem = res.data.targets;
            } else {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }

            this.loading = false;
          }
        });
      }
    },
    getMyAddedIPCRTarget(data) {
      // console.log("getMyAddedIPCRTarget", data);
      this.taggedIDs = [];
      for (const item of data) {
        if (item.isLinkedToMyHeadOPCR == 1) {
          this.taggedIDs.push({
            id: item.linked_head_opcr_targetID ?? item.linked_head_pap_taggedID,
            sp_type: item.sp_type,
          });
        }

        if (item.isLinkedToMyOPCR == 1) {
          this.taggedIDs.push({
            id: item.linked_my_opcr_targetID ?? item.linked_my_pap_taggedID,
            sp_type: item.sp_type,
          });
        }
      }
    },

    setPendingClass(item) {
      if (this.assesed_by_status == 3) {
        if (this.tab != 3) {
          let list = item.pendingRemarks;
          let has = false;
          if (list) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].isOpenned == 0) {
                has = true;
                break;
              }
            }
            if (has) {
              return "red lighten-4";
            }
          }
          return "";
        }
      }
      return "";
    },

    hasUnOpennedRemarks(list) {
      if (list && list.length > 0) {
        let has = false;
        for (let i = 0; i < list.length; i++) {
          if (list[i].isOpenned == 0) {
            has = true;
            break;
          }
        }
        if (has) {
          return has;
        } else {
          if (this.assesed_by_status != 2 && this.isSubmitted) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    showPendingRemarks(item) {
      this.pendingList = [];
      setTimeout(() => {
        this.pendingList = item;
      }, 100);
    },

    showDelete(item) {
      if (this.tab == 1) {
        return item.target_for == "Designation" || item.target_for == null;
      } else if (this.tab == 2) {
        return true;
      } else if (this.tab == 3) {
        return (
          item.type &&
          (item.type == "Intervening Function" ||
            item.type == "Professional Development")
        );
      }
    },

    addBtnDisableCheck() {
      if (this.tab == 2) {
        return this.dataItem.length == this.data.facultyStrategicIndicator;
      }
      if (this.tab == 3) {
        return this.getProfDevCount == 2;
      }
    },

    shouldSubmit() {
      if (this.isSubmitted == 0) {
        return true;
      } else {
        if (this.assesed_by_status == 1 || this.assesed_by_status == 2) {
          return false;
        } else {
          return true;
        }
      }
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/IPCR_TARGET", "GET").then((res) => {
          if (res.data) {
            // console.log("remarks", res.data);
            this.remarksData = res.data;
          }
        });
      }
    },
    closeD() {
      this.eventHub.$emit("closeViewIPCRFunctionDialog", false);
      this.confirmSubmitDialog = false;
      this.confirmBtnLoading = false;
      this.isSubmitLoading = false;
      this.dialog = false;
    },
    edit(item) {
      // console.log("ITEMS", item);
      Object.assign(item, {
        isFaculty: this.data.isFaculty,
        year: this.data.year,
        // target_for: this.data.target_for,
      });
      if (this.tab != 3) {
        this.ipcrData = item;
        this.action = "Update";
      } else {
        this.ipcrSupData = item;
        this.action = "Update";
      }
    },
    async submitTarget() {
      if (this.data && this.data.isFaculty == 1) {
        let validate = [0, 0];
        let spResponse = await this.axiosCall(
          "/ipcr-target/getMyIPCRTarget/" + this.id + "/2",
          "GET",
        );

        let spTargets = spResponse.data.targets;
        console.log(
          "SP RESPONSE",
          spTargets.length,
          this.data.facultyStrategicIndicator,
        );
        if (spTargets.length == this.data.facultyStrategicIndicator) {
          validate[0] = 1;
        }

        let sfResponse = await this.axiosCall(
          "/ipcr-target/getMyIPCRSFAndProfessionalDevelopment/" + this.id,
          "GET",
        );

        let sfTargets = sfResponse.data.targets;
        let profDevCnt = 0;
        for (let i = 0; i < sfTargets.length; i++) {
          if (sfTargets[i].type == "Professional Development") {
            profDevCnt++;
          }
        }
        if (profDevCnt >= 2) {
          validate[1] = 1;
        } else {
          validate[1] = 0;
        }
        console.log(profDevCnt, validate);

        if (validate.includes(0)) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.timeout = 5000;
          this.fadeAwayMessage.message =
            "Please comply the minimum number of Indicators/Professional Development!";
        } else {
          this.confirmSubmitDialog = true;
        }
      } else {
        this.confirmSubmitDialog = true;
      }
    },

    confirmSubmit() {
      this.confirmBtnLoading = true;
      // this.isSubmitLoading = true;
      this.axiosCall("/ipcr-target/submitMyTargets/" + this.id, "PATCH").then(
        (res) => {
          if (res.data.status == 200) {
            this.confirmBtnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        },
      );
    },

    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },

    AddFunction() {
      this.ipcrData = {
        id: null,
        isFaculty: this.data.isFaculty,
        year: this.data.year,
        isDesignated: this.data.facultyType == "designated",
      };
      this.action = "Add";
    },

    AddSupportFunction() {
      // console.log("DATA IREM", this.dataItem);
      let hasInterveningFunction = false;
      for (let i = 0; i < this.dataItem.length; i++) {
        if (this.dataItem[i].func_type == 2) {
          hasInterveningFunction = true;
          break;
        }
      }
      console.log("HAS INTERVENING FUNCTION", hasInterveningFunction);
      if (!hasInterveningFunction) {
        this.ipcrSupport = {
          id: null,
          isFaculty: this.data.isFaculty,
          year: this.data.year,
          hasInterveningFunction: hasInterveningFunction,
        };
        this.action = "Add";
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "You already have Intervening Function.";
      }
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },

    confirmDelete() {
      this.isButtonLoading = true;
      let url;
      if (this.tab == 3) {
        url = "/ipcr-support/deleteMySupport/" + this.itemToDelete.id;
      } else {
        url = "/ipcr-target/deleteTarget/" + this.itemToDelete.id;
      }

      this.axiosCall(url, "DELETE").then((res) => {
        if (res.data.status == 200) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
          this.itemToDelete = null;
          this.confirmDialog = false;

          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
        }
      });
    },

    getUsers() {
      this.axiosCall("/user-details/getAllUserDetail", "GET").then((res) => {
        this.users = res.data;
        // console.log(res.data);
      });
    },

    getUserName(id) {
      if (this.users.length > 0) {
        let idx = this.users.findIndex((u) => u.id == id);
        return this.users[idx].name;
        // return this.toTitleCase(this.users[idx].name);
      }
      return;
    },
    printTargets() {
      // alert(this.data.id);
      console.log(this.data);
      let url;
      if (this.data.isFaculty == 0) {
        url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/generateIPCRForm/TARGET/" +
          this.data.id;
      } else {
        url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/facultyIPCR/TARGET/" +
          this.data.id;
      }

      let token = localStorage.getItem("token");
      this.isLoading = true;
      const tab = window.open("about:blank");
      fetch(url, { headers: { Authorization: `Bearer ${token}` } }) // FETCH BLOB FROM IT
        .then((response) => response.blob())
        .then((blob) => {
          // RETRIEVE THE BLOB AND CREATE LOCAL URL
          var _url = window.URL.createObjectURL(blob);

          // window.open(_url, "_blank").focus();
          tab.location = _url;
          tab.focus();
          this.isLoading = false; // window.open + focus
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.preserve-whitespace {
  white-space: pre-line;
  word-wrap: break-word;
}
</style>
